import { http } from "../api/http";
import Utils from "../utils";

export const inspectRequestService = {
  get,
};

function get(requestParameters) {
  let url = `/inspectrequest`;
  if (requestParameters && Object.keys(requestParameters).length > 0) {
    url += `?${Utils.objectToQueryString(requestParameters)}`;
  }
  return http.get(url).then((response) => response);
}
